/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { PortfolioUpdateRequestModel } from '@app/app/page-modules/portfolio/models';
import { Page } from '@app/app/shared/models/page';
import { PortfolioModel } from '@app/app/shared/models/portfolio/portfolio.model';
import { PortfolioDataService } from '@app/app/shared/services/portfolio/data.service';
import { ObservableResult } from '@app/app/shared/store';

export class MockPortfolioDataService implements PortfolioDataService {
  getPortfolio(portfolioId: string): ObservableResult<PortfolioModel> {
    return ObservableResult.ofSuccess();
  }

  getUserPortfolios(page: number, pageSize: number): ObservableResult<Page<PortfolioModel>> {
    return ObservableResult.ofSuccess();
  }

  getPublicPortfolio(portfolioId: string): ObservableResult<PortfolioModel> {
    return ObservableResult.ofSuccess();
  }

  updatePortfolio(portfolioId: string, request: PortfolioUpdateRequestModel) {
    return ObservableResult.ofSuccess();
  }

  createPortfolio(request: PortfolioUpdateRequestModel): ObservableResult<PortfolioModel> {
    return ObservableResult.ofSuccess();
  }

  updatePortfolioVisibility(portfolioId: string, isVisible: boolean): ObservableResult<PortfolioModel> {
    return ObservableResult.ofSuccess();
  }

  deletePortfolio(portfolioId: string): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updatePortfolioCohortShare(portfolioId: string, shared: boolean): ObservableResult<PortfolioModel> {
    return ObservableResult.ofSuccess();
  }
}
